import React, { useEffect, useState } from "react";
import { Container, Table, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../common/Footer";
import AdminHeader from "../common/AdminHeader";
import axios from "axios";
import { baseUrl, LEAVING_CERTIFICATE_OL } from "../../Utility/constants";
import { Link } from "react-router-dom"; // For navigation
import {
  LEAVING_CERTIFICATE,
  BONAFIDE_CERTIFICATE,
  ATTEMPT_CERTIFICATE_Name,
  NIRGAMUTARA_CERTIFICATE,
  FORM15_CERTIFICATE,
} from "../../Utility/constants";
import LeavingCertificatePreview from "./LeavingCertificatePreview";
import BonafideCertificateEnglishPreview from "./BonafideCertificateEnglishPreview";
import FormCertificate_15Preview from "./FormCertificate_15Preview";
import Attempt_CertificatePreview from "./Attempt_CertificatePreview";
import Nirgam_UtaraPreview from "./Nirgam_UtaraPreview";
import LeavingCertificateOLPreview from "./LeavingCertificateOLPreview";

const Report = () => {
  const [searchCriteria, setSearchCriteria] = useState("Name"); // Default selected dropdown option
  const [searchValue, setSearchValue] = useState(""); // Textbox value
  const loggedUser = localStorage.getItem("userID"); // Textbox value
  const [students, setStudents] = useState([]);
  const [currentVersion, setCurrentVersion] = useState("");
  const [currentCertificateNumber, setCurrentCertificateNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [student_Id, setStudent_Id] = useState("");
  const [currentCertificateName, setCurrentCertificateName] = useState("");
  const [hasStandardOne, setHasStandardOne] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const [showModalLCOL, setShowModalLCOL] = useState(false);
  const handleCloseModalLCOL = () => setShowModalLCOL(false);

  const [showModalBF, setShowModalBF] = useState(false);
  const handleCloseModalBF = () => setShowModalBF(false);

  const [showModalF15, setShowModalF15] = useState(false);
  const handleCloseModalF15 = () => setShowModalF15(false);

  const [showModalAC, setShowModalAC] = useState(false);
  const handleCloseModalAC = () => setShowModalAC(false);

  const [showModalNU, setShowModalNU] = useState(false);
  const handleCloseModalNU = () => setShowModalNU(false);

  const [lcFormData, setLcFormData] = useState({
    lcVersion: "Original"
  });

  const handleSearch = async () => {
    if (!searchValue) {
      setErrorMessage("Please enter a search value.");
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/api/PersonalDetails/SearchStudentDetails`,
        {
          params: {
            searchCriteria,
            searchValue,
            loggedUser,
          },
        }
      );

      if (response?.data && response?.data.length > 0) {
        if (Number(response?.data[0]?.standardName) === 1 || response?.data[0]?.standardName === "1") {
          setHasStandardOne(true);
        }
      }

      setStudents(response.data); // Set students data in state
      setErrorMessage(""); // Reset any error messages
    } catch (error) {
      setErrorMessage(
        error.response?.data || "Something went wrong while fetching data."
      );
      setStudents([]); // Clear the list in case of an error
    }
  };

  const getLcVersion = async (studentId) => {
    const response = await axios.get(
      `${baseUrl}/api/Numbering/GetLCVersion?studentId=${studentId}`
    );
    console.log(response);
    return response.data;
  };

  const getcertificateNumber = async (certificate_name) => {
    const response = await axios.get(
      `${baseUrl}/api/Numbering/GetCertificateNumber?CertificateName=${certificate_name}`
    );
    console.log(response);
    //return response.data;
    setCurrentCertificateNumber(response.data);
  };

  const onCertificateClick = async (e, studentId, certificate_Name, studentType) => {
    e.preventDefault();
    setStudent_Id(studentId);
    setCurrentCertificateName(certificate_Name);
    try {
      if (certificate_Name === LEAVING_CERTIFICATE) {
        if (studentType?.toLowerCase().includes('private')) {
          setCurrentVersion('PRIVATE');
        }
        else {
          const currentLCVersion = await getLcVersion(studentId);
          setCurrentVersion(currentLCVersion);
        }
        await getcertificateNumber(LEAVING_CERTIFICATE);
        setShowModal(true);
      }
      else if (certificate_Name === LEAVING_CERTIFICATE_OL) {
        const currentLCVersion = await getLcVersion(studentId);
        setCurrentVersion(currentLCVersion);
        await getcertificateNumber(LEAVING_CERTIFICATE);
        setShowModalLCOL(true);
      }
      else if (certificate_Name === BONAFIDE_CERTIFICATE) {
        await getcertificateNumber(BONAFIDE_CERTIFICATE);
        setShowModalBF(true);
      } else if (certificate_Name === FORM15_CERTIFICATE) {
        setShowModalF15(true);
      } else if (certificate_Name === NIRGAMUTARA_CERTIFICATE) {
        setShowModalNU(true);
      } else if (certificate_Name === ATTEMPT_CERTIFICATE_Name) {
        setShowModalAC(true);
      }
    } catch (error) {
      console.error("Error sending data:", error);
    }
  };

  const handleConfirmPrint = (type) => {
    if (type == "LC") {
      setShowModal(false);
      if (currentCertificateName === LEAVING_CERTIFICATE) {

        // window.open(
        //   `/leaving-certificate/${student_Id}/${currentVersion}/${currentCertificateNumber.certificateNo}/${currentCertificateNumber.certificateId}
        //   ?certType=${encodeURIComponent(currentVersion || "")}`,
        //   "_blank"
        // );

        window.open(
          `/leaving-certificate/${student_Id}/${currentVersion}/${currentCertificateNumber.certificateNo}/${currentCertificateNumber.certificateId}
           ?certType=${encodeURIComponent(lcFormData.lcVersion)}`,
          "_blank"
        );

      }
    }
    if (type == "LCOL") {
      setShowModalLCOL(false);
      if (currentCertificateName === LEAVING_CERTIFICATE_OL) {
        window.open(
          `/leaving-certificateol/${student_Id}/${currentVersion}/${currentCertificateNumber.certificateNo}/${currentCertificateNumber.certificateId}`,
          "_blank"
        );
      }
    }
    if (type == "BF") {
      setShowModalBF(false);
      window.open(
        `/bonafide-certificate/${student_Id}/${currentCertificateNumber.certificateNo}/${currentCertificateNumber.certificateId}/${selectedReason?.id}`,
        "_blank"
      );
    }
    if (type == "F15") {
      setShowModalF15(false);
      window.open(`/form15/${student_Id}`, "_blank");
    }
    if (type == "AC") {
      setShowModalAC(false);
      window.open(`/attempt-certificate/${student_Id}`, "_blank");
    }
    if (type == "NU") {
      setShowModalNU(false);
      window.open(`/nirgam-utara-certificate/${student_Id}`, "_blank");
    }
  };

  return (
    <>
      <AdminHeader />
      <Container className="mt-5 mb-5">
        <h3>Reports</h3>
        <div className="container mt-4">
          {/* Search Criteria Dropdown */}
          <div className="row">
            <div className="col-md-3">
              <select
                className="form-control"
                value={searchCriteria}
                onChange={(e) => setSearchCriteria(e.target.value)}>
                <option value="0">Select Search option</option>
                <option value="grno">GR No</option>
                <option value="name">Name</option>
              </select>
            </div>

            {/* Search Value Input */}
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Enter search value"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>

            {/* Search Button */}
            <div className="col-md-2">
              <button className="btn btn-primary" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>

          {/* Display Error Message */}
          {errorMessage && (
            <div className="alert alert-danger mt-3">{errorMessage}</div>
          )}

          <Table striped bordered hover className="mt-4">
            <thead>
              <tr>
                <th style={{ backgroundColor: "#0d6efd", color: "white" }}>
                  LC - Leaving Certificate
                </th>
                <th style={{ backgroundColor: "#6c757d", color: "white" }}>
                  BR - Bonafide Report
                </th>
                <th style={{ backgroundColor: "#198754", color: "white" }}>
                  F15 - Form 15
                </th>
                <th style={{ backgroundColor: "#ffc107", color: "black" }}>
                  AC - Attempt Certificate
                </th>
                <th style={{ backgroundColor: "#17a2b8", color: "black" }}>
                  NU - Nirgam Utara
                </th>
              </tr>
            </thead>
          </Table>

          {/* Display Student List in a Table */}
          {students.length > 0 && (
            <div className="mt-4">
              <h4>Student List</h4>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th style={{ width: "50px" }}>#</th>
                    <th style={{ width: "70px" }}>Roll No</th>
                    <th style={{ width: "300px" }}>Full Name</th>
                    <th style={{ width: "250px" }}>Stream | Standard | Section </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {students.map((student, index) => (
                    <tr key={student.studentId}>
                      <td>{index + 1}</td>
                      <td>{student.rollNo}</td>
                      <td>{student.firstName} {student.middleName} {student.lastName} </td>
                      <td>{student.streamName} {student.standardName} {student.sectionName}</td>
                      <td>
                        <Link
                          className="btn btn-primary mr-2"
                          target="_blank"
                          to="#" //{`/leaving-certificate/${student.studentId}`}
                          onClick={(e) =>
                            onCertificateClick(
                              e,
                              student.studentId,
                              LEAVING_CERTIFICATE,
                              student.studentType
                            )
                          }
                        >
                          L C
                        </Link>
                        {
                          student.lcolExists === "YES" &&
                          <Link
                            className="btn btn-primary mr-2"
                            target="_blank"
                            to="#" //{`/leaving-certificate/${student.studentId}`}
                            onClick={(e) =>
                              onCertificateClick(
                                e,
                                student.studentId,
                                LEAVING_CERTIFICATE_OL
                              )
                            }
                          >
                            L C O L
                          </Link>
                        }
                        <Link
                          className="btn btn-secondary mr-2"
                          target="_blank"
                          to="#" //{`/bonafide-certificate/${student.studentId}`}
                          onClick={(e) =>
                            onCertificateClick(
                              e,
                              student.studentId,
                              BONAFIDE_CERTIFICATE
                            )
                          }
                        >
                          B R
                        </Link>
                        <Link
                          className="btn btn-success mr-2"
                          target="_blank"
                          to="#" //{`/form15/${student.studentId}`}
                          onClick={(e) =>
                            onCertificateClick(
                              e,
                              student.studentId,
                              FORM15_CERTIFICATE
                            )
                          }
                        >
                          F 15
                        </Link>
                        <Link
                          className="btn btn-warning mr-2"
                          target="_blank"
                          to="#" //{`/attempt-certificate/${student.studentId}`}
                          onClick={(e) =>
                            onCertificateClick(
                              e,
                              student.studentId,
                              ATTEMPT_CERTIFICATE_Name
                            )
                          }
                        >
                          AC
                        </Link>
                        {/* {hasStandardOne && ( */}
                        {/* {parseInt(student.standardName) === 1 && ( */}
                        <Link
                          className="btn btn-info mr-2"
                          target="_blank"
                          to="#" //{`/nirgam-utara-certificate/${student.studentId}`}
                          onClick={(e) =>
                            onCertificateClick(
                              e,
                              student.studentId,
                              NIRGAMUTARA_CERTIFICATE
                            )
                          }
                        >
                          N U
                        </Link>
                        {/* )} */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
        <ToastContainer />
        {/* LC Modal */}
        {showModal && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Leaving Certificate Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModal}
                  ></button>
                </div>
                <div className="modal-body">
                  {/* Render the LeavingCertificatePreview component */}
                  <LeavingCertificatePreview
                    currentVersion={currentVersion}
                    currentCertificateNumber={
                      currentCertificateNumber.certificateNo
                    }
                    lcType={currentCertificateName}
                    studentId={student_Id}
                    setLcFormData={setLcFormData}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleConfirmPrint("LC")}
                  >
                    Confirm and Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* LCOL Modal */}
        {showModalLCOL && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Leaving Certificate Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModalLCOL}
                  ></button>
                </div>
                <div className="modal-body">
                  {/* Render the LeavingCertificatePreview component */}
                  <LeavingCertificateOLPreview
                    currentVersion={currentVersion}
                    currentCertificateNumber={
                      currentCertificateNumber.certificateNo
                    }
                    lcType={currentCertificateName}
                    studentId={student_Id}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleConfirmPrint("LCOL")}
                  >
                    Confirm and Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModalLCOL}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bonafide Modal */}
        {showModalBF && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Bondafide Certificate Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModalBF}
                  ></button>
                </div>
                <div className="modal-body">
                  <BonafideCertificateEnglishPreview
                    currentCertificateNumber={
                      currentCertificateNumber.certificateNo
                    }
                    studentId={student_Id}
                    onReasonChange={setSelectedReason}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleConfirmPrint("BF")}
                  >
                    Confirm and Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModalBF}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bonafide Modal */}
        {showModalF15 && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Form 15 Certificate Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModalF15}
                  ></button>
                </div>
                <div className="modal-body">
                  <FormCertificate_15Preview
                    studentId={student_Id}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleConfirmPrint("F15")}
                  >
                    Confirm and Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModalF15}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bonafide Modal */}
        {showModalAC && (
          <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Attempt Certificate Preview</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModalAC}
                  ></button>
                </div>
                <div className="modal-body">
                  <Attempt_CertificatePreview
                    studentId={student_Id}
                  />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => handleConfirmPrint("AC")}
                  >
                    Confirm and Print
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCloseModalAC}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bonafide Modal */}
        {showModalNU && (
          <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Nirgam Utara Certificate Preview</h5>
                  <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModalNU}></button>
                </div>
                <div className="modal-body table-responsive">
                  <Nirgam_UtaraPreview studentId={student_Id} />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={() => handleConfirmPrint("NU")}>
                    Confirm and Print
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModalNU}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

        )}
      </Container>
      <Footer />
    </>
  );
};

export default Report;
